/**
 * Server environment variables.
 *
 * @remarks
 * These environment variables are required for the server to function
 * properly. Make sure to set them in your .env file.
 *
 * @property {string} LEMON_SQUEEZY_API_KEY - Lemon Squeezy API key.
 * @property {string} LEMON_SQUEEZY_STORE_ID - Lemon Squeezy store ID.
 * @property {string} LEMON_SQUEEZY_MONTHLY_SUPPORTER_VARIANT_ID - Lemon Squeezy monthly supporter variant ID.
 * @property {string} LEMON_SQUEEZY_ANNUAL_SUPPORTER_VARIANT_ID - Lemon Squeezy annual supporter variant ID.
 * @property {string} LEMON_SQUEEZY_WEBHOOK_SECRET - Lemon Squeezy webhook secret.
 * @property {string} PATREON_CLIENT_ID - Patreon client ID.
 * @property {string} PATREON_CLIENT_SECRET - Patreon client secret.
 * @property {string} GITHUB_CLIENT_ID - GitHub client ID.
 * @property {string} GITHUB_CLIENT_SECRET - GitHub client secret.
 * @property {string} GITHUB_OAUTH_TOKEN - GitHub OAuth token.
 * @property {string} GOOGLE_CLIENT_ID - Google client ID.
 * @property {string} GOOGLE_CLIENT_SECRET - Google client secret.
 * @property {string} AUTH_JWT_SECRET - JWT secret.
 * @property {string} TELEGRAM_BOT_TOKEN - Telegram bot token.
 * @property {string} TELEGRAM_CHAT_ID - Telegram chat ID.
 * @property {string} BEEHIIV_API_KEY - Beehiiv API key.
 * @property {string} BEEHIIV_PUBLICATION_ID - Beehiiv publication ID.
 */
const Environment = {
  LEMON_SQUEEZY_API_KEY: process.env.LEMON_SQUEEZY_API_KEY,
  LEMON_SQUEEZY_STORE_ID: process.env.LEMON_SQUEEZY_STORE_ID,
  LEMON_SQUEEZY_MONTHLY_SUPPORTER_VARIANT_ID:
    process.env.LEMON_SQUEEZY_MONTHLY_SUPPORTER_VARIANT_ID,
  LEMON_SQUEEZY_ANNUAL_SUPPORTER_VARIANT_ID:
    process.env.LEMON_SQUEEZY_ANNUAL_SUPPORTER_VARIANT_ID,
  LEMON_SQUEEZY_WEBHOOK_SECRET: process.env.LEMON_SQUEEZY_WEBHOOK_SECRET,
  PATREON_CLIENT_ID: process.env.PATREON_CLIENT_ID,
  PATREON_CLIENT_SECRET: process.env.PATREON_CLIENT_SECRET,
  GITHUB_CLIENT_ID: process.env.GITHUB_CLIENT_ID,
  GITHUB_CLIENT_SECRET: process.env.GITHUB_CLIENT_SECRET,
  GITHUB_OAUTH_TOKEN: process.env.GITHUB_OAUTH_TOKEN,
  GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
  GOOGLE_CLIENT_SECRET: process.env.GOOGLE_CLIENT_SECRET,
  AUTH_JWT_SECRET: process.env.AUTH_JWT_SECRET,
  TELEGRAM_BOT_TOKEN: process.env.TELEGRAM_BOT_TOKEN,
  TELEGRAM_CHAT_ID: process.env.TELEGRAM_CHAT_ID,
  BEEHIIV_API_KEY: process.env.BEEHIIV_API_KEY,
  BEEHIIV_PUBLICATION_ID: process.env.BEEHIIV_PUBLICATION_ID,
  APPLE_TEAM_ID: process.env.APPLE_TEAM_ID,
  APPLE_CLIENT_ID: process.env.APPLE_CLIENT_ID,
  APPLE_CLIENT_SECRET: process.env.APPLE_CLIENT_SECRET,
} as const;

export const ServerEnvironment = Environment as Record<
  keyof typeof Environment,
  string
>;

Object.entries(ServerEnvironment).forEach(([key, value]) => {
  if (!value) {
    throw new Error(`${key} is not set`);
  }
});
